import React, { useEffect, useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setStartDate, setEndDate, setSearchTerm } from 'redux/briefing/archiveSearchSlice';

const DEBOUNCE_MS = 400;

const ControlPanel = () => {
    const dispatch = useDispatch();

    // Read current values from redux
    const startDateRedux = useSelector((state) => state.archiveSearch.startDate);
    const endDateRedux = useSelector((state) => state.archiveSearch.endDate);
    const searchTermRedux = useSelector((state) => state.archiveSearch.searchTerm);
    const briefing = useSelector((state) => state.briefing);

    // Local input state (editable) seeded from redux
    const [startDate, setStartDateState] = useState(startDateRedux || '');
    const [endDate, setEndDateState] = useState(endDateRedux || '');
    const [searchTerm, setSearchTermState] = useState(searchTermRedux || '');

    // Keep inputs in sync if redux changes elsewhere
    useEffect(() => { setStartDateState(startDateRedux || ''); }, [startDateRedux]);
    useEffect(() => { setEndDateState(endDateRedux || ''); }, [endDateRedux]);
    useEffect(() => { setSearchTermState(searchTermRedux || ''); }, [searchTermRedux]);

    // Debounced dispatch on any input change
    useEffect(() => {
        const t = setTimeout(() => {
            // Only dispatch if something actually changed compared to redux
            if (startDate !== startDateRedux) dispatch(setStartDate(startDate));
            if (endDate !== endDateRedux) dispatch(setEndDate(endDate));
            if (searchTerm !== searchTermRedux) dispatch(setSearchTerm(searchTerm.trim()));
        }, DEBOUNCE_MS);

        return () => clearTimeout(t);
    }, [startDate, endDate, searchTerm, startDateRedux, endDateRedux, searchTermRedux, dispatch]);

    return (
        <div className="briefing-control-panel">
            <Row>
                <Col md={12}>
                    <Form.Group controlId="searchTerm">
                        <Form.Label>Search</Form.Label>
                        <Form.Control
                            className="input"
                            type="text"
                            placeholder="Enter search term"
                            value={searchTerm}
                            onChange={(e) => setSearchTermState(e.target.value)}
                        />
                    </Form.Group>
                </Col>
            </Row>


            {briefing.line === 'Old Briefings' && (
                <>
                    <br />

                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="startDate">
                                <Form.Label>Start Date</Form.Label>
                                <Form.Control
                                    className="input"
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDateState(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="endDate">
                                <Form.Label>End Date</Form.Label>
                                <Form.Control
                                    className="input"
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDateState(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </>
            )}

            <br />
        </div>
    );
};

export default ControlPanel;
